<template>
    <a-modal
            :width="'50%'"
            v-model="addEntity"
            :title="$t('supervise.addEntity')"
            :maskClosable="maskClosable"
            :confirmLoading="isLoading"
            @cancel="onCancel"
            @ok="handleOk">

        <div style="padding:20px;">
            <a-card>
                <a-form :form="form">
                    <a-form-item :label="$t('global.org')" v-bind="formItemLayout">
                        <z-org-chooser ref="orgChooser" :option="orgOption" @orgSelect="onOrgSelect"></z-org-chooser>
                    </a-form-item>

                    <a-form-item :label="$t('supervise.group')" v-bind="formItemLayout">
                        <a-select  v-model="groupId" size="small" v-decorator="['groupId',{ rules: [{ required: true, message: $t('global.isRequired') }] }] ">
                            <a-select-option v-for="group in groups" :key="group.groupId" >{{group.groupName}}</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item  v-for="item in fields" :label="$t(`columnCheck.${item.name}`)" :key="item.name" v-bind="formItemLayout">
                        <a-input-number v-model="item.value" size="small" v-if="item.inputType == 'number'" style="width:100%"  v-decorator="item.isCrucial || item.isRequire ? [item.name,{ rules: [{ required: true, message: $t('global.isRequired') }] }] : [item.name,{ rules: null }]"></a-input-number>
                        <a-input v-model="item.value" size="small" v-if="item.inputType == 'text'"  v-decorator="item.isCrucial || item.isRequire ? [item.name,{ rules: [{ required: true, message: $t('global.isRequired') }] }] : [item.name,{ rules: null }]"></a-input>
                        <a-select  v-model="item.value" v-if="item.inputType == 'selectBox'" size="small" v-decorator="item.isCrucial || item.isRequire ? [item.name,{ rules: [{ required: true, message: $t('global.isRequired') }] }] :[item.name,{ rules: null }] ">
                            <a-select-option v-for="selectItem in item.dataSource.split(',')" :key="selectItem" >{{selectItem}}</a-select-option>
                        </a-select>
                        <a-date-picker v-model="item.value" size="small" v-if="item.inputType == 'date'" style="width:100%" v-decorator="item.isCrucial || item.isRequire ? [item.name,{ rules: [{ required: true, message: $t('global.isRequired') }] }] :[item.name,{ rules: null }]"></a-date-picker>
                        <UploadImage v-model="item.value" v-if="item.inputType === 'image'" />
                    </a-form-item>
                </a-form>
            </a-card>
        </div>

    </a-modal>
</template>

<script>
    import config from '@/config'
    import ZOrgChooser from '@/components/common/OrgChooser.vue'
    import UploadImage from '@/components/common/UploadImage'
    // import moment from 'moment'
    export default {
        name: 'ZAddEntity',
        data() {
            return{
                maskClosable: false,
                addEntity: false,
                form: null,
                fields:[],
                isLoading: false,
                orgId: null,
                groupId: null,
                groups: [],
                orgOption:{
                    id: "addEntityOrg",
                    value: ""
                },
                formItemLayout: {
                    labelCol: {
                        xs: { span: 20 },
                        sm: { span: 8 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 },
                    }
                }
            }
        },
        components: {
            ZOrgChooser,
            UploadImage
        },
        methods: {
            onCancel(){
                this.fields = []
                this.isLoading = false
            },
            onOrgSelect(org){
                this.orgId = org.id
                // console.log(this.fields)
                if(this.fields.length == 0){
                    this.$http.get(config.api.entity_template_org_url + "/" + org.id).then((response) => {
                        if(response.code == 0){
                            this.fields = response.result.attrs
                            this.fields.map(function(item){
                                item.value = null
                            })
                        }
                    }).catch((err) => {
                        console.log(err)
                    })
                }else{
                    // this.fields.map(function(item){
                    //             item.value = null
                    //         })
                }
                // // this.form.resetFields()
                // console.log(this.fields)
                this.$http.get(config.api.entity_group_summary_url + '/' + org.id).then((response) => {
                    if(response.code == 0){
                        // console.log(response)
                        // let groups = response.result
                        // tmpGroups.map(m=>{ 
                        //     return m.groupName = this.$t(`global.${m.groupName}`)
                        // })
                        this.groups = response.result
                        this.groupId = org.defaultEntityGroupId
                        this.form.setFieldsValue({
                            groupId: org.defaultEntityGroupId
                        });
                        // console.log(this.form)
                    }
                }).catch((err) => {
                    console.log(err)
                })
            },
            handleOk(){
                this.isLoading = true
                this.form.validateFieldsAndScroll((err, values) => {
                    if (!err) {
                        let params = []
                        let param = {}
                        let attrs = {}
                        this.fields.map(function(item){
                            if(item.value && item.value != ''){
                                // let attr = {}
                                if(item.inputType == 'date'){
                                    attrs[item.name] = (item.value.valueOf()/1000).toFixed() + ''
                                }else{
                                    attrs[item.name] = item.value + ''
                                }
                            }
                        })
                        param.entityGroupId = this.groupId
                        param.attrs = attrs
                        params.push(param)
                        let _this = this
                        // console.log(params)
                        this.$http.post(config.api.entity_url + "/" + this.orgId,params).then((response) => {
                            this.isLoading = false
                            if(response.code == 0){
                                _this.fields = []
                                // _this.$message.success('添加实体成功')
                                this.$notification.success({
                                  message: this.$t('global.commitSuccess')
                                })
                                _this.$emit('success');
                                _this.addEntity = false
                            } else {
                               _this.$message.error(response.desc)
                            }
                        }).catch((err) => {
                            console.log(err)
                            _this.$message.error('服务器错误请稍后再试！')
                        })
                    } else {
                        this.isLoading = false
                    }
                })
            },
            showModel(){
                this.addEntity = true
                this.form = this.$form.createForm(this)
                if(this.$refs["orgChooser"]){
                    this.$refs["orgChooser"].initOrgTree()
                }
            }
        }
    }
</script>